import React from "react";
import { useRoutes } from "react-router-dom";
import Login from "./screens/Login";
import Home from "./layout/Home";
import DashboardLayout from "./layout/dashboard";

export const AppRouter = () => {
  const elements = useRoutes([
    { path: "/", element: <Login /> },
    { path: "/home/*", element: <DashboardLayout /> },
  ]);
  return elements;
};
